/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightExchangeQuoteSummary
 */
export interface FlightExchangeQuoteSummary {
  /**
   *
   * @type {Date}
   * @memberof FlightExchangeQuoteSummary
   */
  observedAt: Date;
  /**
   *
   * @type {Date}
   * @memberof FlightExchangeQuoteSummary
   */
  expiresAt: Date;
  /**
   *
   * @type {string}
   * @memberof FlightExchangeQuoteSummary
   */
  currency: string | null;
  /**
   * Exact amount; null means supplier evidence is unavailable.
   * @type {string}
   * @memberof FlightExchangeQuoteSummary
   */
  additionalCollection: string | null;
  /**
   * Exact amount; null means supplier evidence is unavailable.
   * @type {string}
   * @memberof FlightExchangeQuoteSummary
   */
  penalty: string | null;
  /**
   * Exact amount; null means supplier evidence is unavailable.
   * @type {string}
   * @memberof FlightExchangeQuoteSummary
   */
  replacementTotal: string | null;
  /**
   * Exact amount; null means supplier evidence is unavailable.
   * @type {string}
   * @memberof FlightExchangeQuoteSummary
   */
  fareDifference: string | null;
  /**
   * Exact amount; null means supplier evidence is unavailable.
   * @type {string}
   * @memberof FlightExchangeQuoteSummary
   */
  taxDifference: string | null;
  /**
   * Exact amount; null means supplier evidence is unavailable.
   * @type {string}
   * @memberof FlightExchangeQuoteSummary
   */
  supplierFee: string | null;
  /**
   * Exact amount; null means supplier evidence is unavailable.
   * @type {string}
   * @memberof FlightExchangeQuoteSummary
   */
  serviceFee: string | null;
  /**
   * Exact amount; null means supplier evidence is unavailable.
   * @type {string}
   * @memberof FlightExchangeQuoteSummary
   */
  residualValue: string | null;
  /**
   *
   * @type {string}
   * @memberof FlightExchangeQuoteSummary
   */
  refundDestination: FlightExchangeQuoteSummaryRefundDestinationEnum | null;
}

/**
 * @export
 */
export const FlightExchangeQuoteSummaryRefundDestinationEnum = {
  OriginalPayment: "original_payment",
  SupplierCredit: "supplier_credit",
  Unknown: "unknown",
} as const;
export type FlightExchangeQuoteSummaryRefundDestinationEnum =
  (typeof FlightExchangeQuoteSummaryRefundDestinationEnum)[keyof typeof FlightExchangeQuoteSummaryRefundDestinationEnum];

/**
 * Check if a given object implements the FlightExchangeQuoteSummary interface.
 */
export function instanceOfFlightExchangeQuoteSummary(
  value: object
): value is FlightExchangeQuoteSummary {
  if (!("observedAt" in value) || value["observedAt"] === undefined)
    return false;
  if (!("expiresAt" in value) || value["expiresAt"] === undefined) return false;
  if (!("currency" in value) || value["currency"] === undefined) return false;
  if (
    !("additionalCollection" in value) ||
    value["additionalCollection"] === undefined
  )
    return false;
  if (!("penalty" in value) || value["penalty"] === undefined) return false;
  if (!("replacementTotal" in value) || value["replacementTotal"] === undefined)
    return false;
  if (!("fareDifference" in value) || value["fareDifference"] === undefined)
    return false;
  if (!("taxDifference" in value) || value["taxDifference"] === undefined)
    return false;
  if (!("supplierFee" in value) || value["supplierFee"] === undefined)
    return false;
  if (!("serviceFee" in value) || value["serviceFee"] === undefined)
    return false;
  if (!("residualValue" in value) || value["residualValue"] === undefined)
    return false;
  if (
    !("refundDestination" in value) ||
    value["refundDestination"] === undefined
  )
    return false;
  return true;
}

export function FlightExchangeQuoteSummaryFromJSON(
  json: any
): FlightExchangeQuoteSummary {
  return FlightExchangeQuoteSummaryFromJSONTyped(json, false);
}

export function FlightExchangeQuoteSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightExchangeQuoteSummary {
  if (json == null) {
    return json;
  }
  return {
    observedAt: new Date(json["observed_at"]),
    expiresAt: new Date(json["expires_at"]),
    currency: json["currency"],
    additionalCollection: json["additional_collection"],
    penalty: json["penalty"],
    replacementTotal: json["replacement_total"],
    fareDifference: json["fare_difference"],
    taxDifference: json["tax_difference"],
    supplierFee: json["supplier_fee"],
    serviceFee: json["service_fee"],
    residualValue: json["residual_value"],
    refundDestination: json["refund_destination"],
  };
}

export function FlightExchangeQuoteSummaryToJSON(
  json: any
): FlightExchangeQuoteSummary {
  return FlightExchangeQuoteSummaryToJSONTyped(json, false);
}

export function FlightExchangeQuoteSummaryToJSONTyped(
  value?: FlightExchangeQuoteSummary | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    observed_at: value["observedAt"].toISOString(),
    expires_at: value["expiresAt"].toISOString(),
    currency: value["currency"],
    additional_collection: value["additionalCollection"],
    penalty: value["penalty"],
    replacement_total: value["replacementTotal"],
    fare_difference: value["fareDifference"],
    tax_difference: value["taxDifference"],
    supplier_fee: value["supplierFee"],
    service_fee: value["serviceFee"],
    residual_value: value["residualValue"],
    refund_destination: value["refundDestination"],
  };
}
